import { BASE_URL as TRANSACTIONS_BASE_URL } from "./PageUrls";

const BASE_URL = "/pay-by-link";

export const PAGE_URLS = {
  create: `${TRANSACTIONS_BASE_URL}${BASE_URL}/create`,
  createRedirect: `${BASE_URL}/create`,
} as const;
